@use 'sass:map';
@import '@helsenorge/designsystem-react/scss/breakpoints';
@import '@helsenorge/designsystem-react/scss/spacers';

.exit-wrapper {
  display: flex;
  flex-direction: column;
  row-gap: 5.3rem;
  margin-top: 3rem;
  margin-bottom: 5.3rem;

  @media (max-width: map.get($grid-breakpoints, lg)) {
    margin-top: 3rem;
  }

  @media (max-width: map.get($grid-breakpoints, md)) {
    row-gap: 3rem;
  }
}

.exit-container {
  position: relative;
  z-index: 10;
  display: flex;
  flex-flow: column wrap;
  align-items: flex-start;

  &__text {
    color: #fff;
    font-family: Avenir, Montserrat, Poppins, serif;
    font-size: 1.5rem;
    font-weight: 400;
    line-height: 2rem;
    margin: 0.125rem 0 1.5rem;
    white-space: pre-line;
    vertical-align: bottom;

    @media (max-width: map.get($grid-breakpoints, md)) {
      font-size: 0.87rem;
      line-height: 1.3rem;
    }
  }
}
